import React from "react"
/* custom component */
import Header from "../../../../component/Header/Header"
import { PageContainer, LayoutContainer } from "../../../../component/Xcomponent"
import ContentRepoAdd from "../../../../component/ContentRepo/ContentRepoAdd/ContentRepoAdd";

export const ContentRepoDoctorAdd = props => {
    /* variables */
    const article_id = props.match.params.article_id
    const mode = article_id ? "edit" : "add"

    return (
        <>

            <Header
                backButton={"/content-repo-doctor/list"}
                title={mode === "edit" ? "Edit Content Repo Doctor" : "Add Content Repo Doctor"}
            />
            <PageContainer>
                <LayoutContainer>
                    <ContentRepoAdd pageUrl={`content-repo-doctor`} pageType="Doctor" article_id={article_id} />
                </LayoutContainer>
            </PageContainer>
        </>
    )
}

export default ContentRepoDoctorAdd;